const testimonials = [
  {
    name: "Jessica M.",
    location: "Panama City Beach, FL",
    rating: 5,
    text: "My husband and I had a cruise leaving from Miami in 5 days and I realized my passport was expired. Fast Passport Center got my renewal back to me in 4 days flat. Their team was incredibly responsive and kept me calm during a stressful time.",
    service: "Passport Renewal",
  },
  {
    name: "Marcus T.",
    location: "Lynn Haven, FL",
    rating: 5,
    text: "I needed a passport for a work trip to Germany with only 2 weeks notice. I thought I was out of luck living in the Panhandle. FPC made the whole process so easy — ship overnight and they handle everything. Got it back in 6 days.",
    service: "New Passport",
  },
  {
    name: "Rachel D.",
    location: "Destin, FL",
    rating: 5,
    text: "My teenager's passport got water damaged right before our family trip to the Caribbean. I panicked, but FPC walked me through the replacement step by step. They even told me exactly which clerk to visit in Panama City. Amazing service.",
    service: "Damaged Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function PanamaCityTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Panama City Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Panama City, Panama City Beach, and the Emerald Coast who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}